import React from 'react';
import PropTypes from 'prop-types';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import WizardSpecificPageLinkBottomContent
  from 'Components/ComponentLibrary/Components/Uncategorized/WizardSpecificPageLinkBottom/WizardSpecificPageLinkBottom';

const WizardSpecificPageLinkBottom = ({ resource, onClick }) => {
  return pickFunction(resource, {
    [fr.relationships.specificPageLink.name]: () => {
      if (
        resource.relationship(fr.relationships.specificPageLink.name)?.meta('pageLocation') !== 'bottom'
          || resource.relationship(fr.relationships.specificPageLink.name).meta('prompt') === undefined
      ) {
        return null;
      }

      return (
        <WizardSpecificPageLinkBottomContent
          prompt={resource.relationship(fr.relationships.specificPageLink.name).meta('prompt')}
          onClick={onClick}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

WizardSpecificPageLinkBottom.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default WizardSpecificPageLinkBottom;
